import React, { useState } from "react";
import "./SchemeDifferentiation";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from 'react-icons/ai';

// Import your DebtScheme component here

import SchemeTable from "./SchemeTable/SchemeTable";
import DebtTable from "./DebtTable/DebtTable";

function SchemeDifferentiation() {
    const [showModal, setShowModal] = useState(false);
    const [activeView, setActiveView] = useState(null);

    const handleClosePopup = () => {
        setShowModal(false);
    };

    const handleViewClick = (view) => {
        setActiveView(view);
        setShowModal(true);
    };

    return (
      <>
        <div className="SIDdi-main SIDd product_fund-summary-sc">
          <div className="SIDdis-pnl">
            <div className="siddis">
              <p className="SIDdisHead" style={{textAlign : "start"}}>
                How are Equity and Hybrid Schemes Different from other Equity and Hybrid Schemes of JM Financial Mutual Fund?
              </p>
              <button
                className="SIDdisbutn"
                onClick={() => handleViewClick("equity")}
              >
                View
              </button>
            </div>
          </div>
        </div>

        <div className="SIDdi-main SIDd product_fund-summary-sc">
          <div className="SIDdis-pnl">
            <div className="siddis">
              <p className="SIDdisHead">
                How are Debt Schemes Different from other Debt Schemes of JM
                Financial Mutual Fund?
              </p>
              <button
                className="SIDdisbutn"
                onClick={() => handleViewClick("debt")}
              >
                View
              </button>
            </div>
          </div>
        </div>

        <Modal
          show={showModal}
          autoFocus={true}
          onHide={handleClosePopup}
          backdrop="true"
          keyboard={true}
          className="modal modal-teams"
          style={{ maxHeight: "100vh", overflowY: "hidden" }}
        >
          <Modal.Header closeButton style={{borderBottom: "none"}}>
              <Modal.Title id="scheme-dialog-title" className="sr-only">
                {activeView === "debt"
                    ? "Debt Scheme Details"
                    : "Equity Scheme Details"}
                </Modal.Title>
          </Modal.Header>

          <Modal.Body
            id="modal_info"
            style={{ maxHeight: "90vh", overflowY: "auto" }}
          >
            {/* <div className="btnDiv">
              <button
                type="button"
                className="tblbody"
                onClick={handleClosePopup}
                aria-label="Close dialog"
              >
                <AiFillCloseCircle className="btncl" />
              </button>
            </div> */}
            {/* Render DebtScheme or SchemeTable based on activeView */}
            {activeView === "debt" ? <DebtTable /> : <SchemeTable />}
          </Modal.Body>
        </Modal>
      </>
    );
}

export default SchemeDifferentiation;